exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/_wks-ext.js
// module id = 292
// module chunks = 0 1